module.exports = __webpack_public_path__ + "img/config-example.97d3ce13.png";